import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 14.998a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0-9 0"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 15a10.5 10.5 0 0 1 10.5-10.5m1.5 10.498a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0-9 0"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.75 15a10.5 10.5 0 0 1 10.5-10.5"
    }, null, -1)
  ]));
}
const interfaceTextFormattingLeftOpenQuote = { render };
export {
  interfaceTextFormattingLeftOpenQuote as default,
  render
};
//# sourceMappingURL=interface-text-formatting-left-open-quote.svg.js.map
